import { Button } from "@mui/material"
import { WithRecord, useNotify, useRecordContext, useTranslate } from "react-admin"
import { useMutation } from "react-query";
import { apiService } from "../../apiService";
import fileDownload from "js-file-download";
import { InvoiceReminderReadModel } from "../../GeneratedClients/FreeBillApi";

const DownloadPdfButton = () => {

  const translate = useTranslate()
  const notify = useNotify()
  const record = useRecordContext<InvoiceReminderReadModel>()
  const { mutate, isLoading } = useMutation((id: string) => 
    apiService.InvoiceRemindersApi.downloadInvoiceReminder({id: id}, {responseType: 'blob'}),
    {
      onSuccess: (data) => {
        var pdfFile: any = data.data
        fileDownload(pdfFile, `${record?.textModel?.heading}.pdf`)
        notify(translate("resources.invoices.notifications.downloaded"))
      },
      onError: (error: any) => {
        notify(error, {type: error})
      }
    }   
  )
  const downloadPdf = (id?: string) => { 
    if(id) mutate(id)
  }

  if(!record) return null

  return (
    <WithRecord render={(invoice: InvoiceReminderReadModel) => 
      <Button
        disabled={isLoading} 
        size='small' 
        onClick={() => downloadPdf(invoice.id)} 
      >
        {translate("resources.invoices.actions.download")}
      </Button>
    } />
  )
}

export default DownloadPdfButton